module.exports = __webpack_public_path__ + "static/media/Gaurish_Dodke.d3865bb6.jpg";